import { FunctionComponent } from 'react';
import {Card} from 'react-bootstrap';
import styles from "./ProAccountsCard.module.css";
import cn from 'classnames';

export enum IDifferenceType {
    INCREASE= 'incease',
    DECREASE= 'decrease',
};

interface IProAccountsCardProps {
    title: string;
    value: string | number;
    differenceType?: IDifferenceType;
    differenceText?: string;
    actualDifference?: number;
    className?: string;
};

const ProAccountsCard: FunctionComponent<IProAccountsCardProps> = ({title, value, differenceType, differenceText, actualDifference, className}) => {
    return (
        <Card bsPrefix={cn(styles.proAccountsCard, className)}>
            <Card.Header as={'div'} bsPrefix={styles.cardDataHeader}>
                <Card.Title as={'div'} bsPrefix={styles.cardTitle}>{title}</Card.Title>
                <Card.Text as={'div'} bsPrefix={styles.cardValue}>{value}</Card.Text>
            </Card.Header>
            <Card.Footer as={'div'} bsPrefix={cn(styles.cardDataFooter, differenceType === IDifferenceType.INCREASE ? styles.increase : styles.decrease)}>
                <Card.Text as={'div'} bsPrefix={styles.cardDifference}>{`${differenceType === IDifferenceType.INCREASE && typeof actualDifference === 'number' && actualDifference > 0 ? '+' : ''}${differenceText || ''}`}</Card.Text>
                {/* <Card.Text as={'div'} bsPrefix={styles.cardDifference}>{differenceText}</Card.Text> */}
            </Card.Footer>
        </Card>
    );
};

export default ProAccountsCard;
